

const getReadPerMinute = (text) => {
  const wordsPerMinute = 200;
  const words = text.split(/\s/g).length;
  const readTime = Math.ceil(words / wordsPerMinute);
  return readTime;
}

export default getReadPerMinute;
